import db from "@/db";
import { useInstallationsStore } from "@/store/modules/installations";

function useinstallationPhotos() {
  const removePhotoFromInstallation = async (installation, photoUuid) => {
    await useInstallationsStore().updateInstallation({
      form: {
        uuid: installation.uuid,
        installationPictures: installation.installationPictures.filter(
          (image) => image !== photoUuid
        ),
      },
      setAsCurrent: true,
    });
  };
  const addPhotoToInstallation = async (installation, photo) => {
    let pictureList = [];
    if (Array.isArray(installation.installationPictures)) {
      pictureList = [...installation.installationPictures, photo];
    } else {
      pictureList.push(photo);
    }
    await useInstallationsStore().updateInstallation({
      form: {
        uuid: installation.uuid,
        installationPictures: pictureList,
      },
      setAsCurrent: true,
    });
  };

  const getInstallationIfDocumentIsImage = async (
    documentUuid,
    projectUuid
  ) => {
    const installationsList = await db.installations
      .where({ project: projectUuid })
      .toArray();
    const targetInstallation = installationsList.find((installation) =>
      installation.installationPictures.includes(documentUuid)
    );

    return targetInstallation;
  };

  return {
    removePhotoFromInstallation,
    addPhotoToInstallation,
    getInstallationIfDocumentIsImage,
  };
}

export { useinstallationPhotos };
